import React from 'react';

const SecuritiesAccountFormModal = React.lazy(() => import('../components/FormModal'));
const securitiesAccountModalRegistry = {
    core_securitiesAccountId: SecuritiesAccountFormModal
};
export default securitiesAccountModalRegistry;
